// src/App.jsx
import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { ToastContainer } from "react-toastify";
import AppRoutes from './routes/AppRoutes';

// Import necessary global styles
import 'bootstrap/dist/css/bootstrap.min.css';
import "react-toastify/dist/ReactToastify.css";
import './pages/HomePage.css';

import { ThemeProvider, useTheme } from './context/ThemeContext';

function AppContent() {
 
  const { theme } = useTheme();

  return (
    <>
      <AppRoutes />
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        // 3. Set the theme dynamically
        theme={theme}
      />
    </>
  );
}

// 4. Wrap the content with the ThemeProvider in the main App component
export default function App() {
  return (
    <Router>
      <ThemeProvider>
        <AppContent />
      </ThemeProvider>
    </Router>
  );
}